/* eslint-disable jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for */
import React from 'react';
import { connect } from 'react-redux';
import { Button, Col } from 'reactstrap';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { API, BASE_URL } from '../../../CONST';
import { fileDownload } from '../../../helpers/helpers';
import FormSection from '../../layout/FormSection';

const CorredorGarantiaDetailBasicInfo = ({ policy, loginIdToken }) => {
  if (policy === null) {
    return null;
  }

  const {
    base,
    base: { poliza_maestra: polizaMaestra },
    balancegarantia,
  } = policy;
  return (
    <Col md={{ offset: 2, size: 8 }}>
      <FormSection title={`Información básica - ${base.nemotecnico}`} style={{ marginTop: '70px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gridGap: '20px' }}>
          <div>
            <label htmlFor="ramo-fecu">Ramo FECU</label>
            <p id="ramo-fecu" className="small-form-value">
              {polizaMaestra.ramo_asegurado.descripcion}
            </p>
          </div>
          <div>
            <label htmlFor="moneda">Moneda</label>
            <p id="moneda" className="small-form-value">
              {base.moneda_asegurada.descripcion}
            </p>
          </div>
          <div>
            <label htmlFor="condicionado-general">Condicionado general</label>
            <p id="condicionado-general" className="small-form-value">
              <a
                href={polizaMaestra.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#215797' }}
              >
                <u>{polizaMaestra.nemotecnico}</u>
              </a>
              <Button
                className="form-values download"
                onClick={() =>
                  fileDownload(
                    `${BASE_URL}${API.garantiaIntermediario}/${policy.id}/download-maestra/`,
                    loginIdToken,
                  )
                }
                style={{ marginLeft: '10px' }}
              >
                <FontAwesomeIcon icon={faDownload} />
              </Button>
            </p>
          </div>
          <div>
            <label htmlFor="producto">Producto</label>
            <p id="producto" className="small-form-value">
              {base.producto.descripcion}
            </p>
          </div>
          <div>
            <label htmlFor="tipo-cobertura">Tipo de cobertura</label>
            <p id="tipo-cobertura" className="small-form-value">
              {base.tipo_cobertura.descripcion}
            </p>
          </div>
          <div style={{ gridColumn: '2 / 5' }}>
            <label htmlFor="tipologia-ejecucion">Ejecución</label>
            <p id="tipologia-ejecucion" className="small-form-value">
              {base.tipologia_ejecucion.descripcion}
            </p>
          </div>
          <div>
            <label htmlFor="tipo-intermediario">Tipo de intermediario</label>
            <p id="tipo-intermediario" className="small-form-value">
              {balancegarantia.tipo_intermediario.descripcion}
            </p>
          </div>
          <div>
            <label htmlFor="intermediario">Intermediario</label>
            <p id="intermediario" className="small-form-value">
              {balancegarantia.intermediario
                ? `${balancegarantia.intermediario.rut} - ${balancegarantia.intermediario.nombre}`
                : ''}
            </p>
          </div>
          <div>
            <label htmlFor="asegurado">Asegurado</label>
            <p id="asegurado" className="small-form-value">
              {policy.asegurado.nombre}
            </p>
          </div>
        </div>
      </FormSection>
    </Col>
  );
};

CorredorGarantiaDetailBasicInfo.propTypes = {
  policy: PropTypes.shape({
    id: PropTypes.number.isRequired,
    base: PropTypes.object,
    asegurado: PropTypes.object,
    balancegarantia: PropTypes.object,
  }),
  loginIdToken: PropTypes.string.isRequired,
};

CorredorGarantiaDetailBasicInfo.defaultProps = {
  policy: null,
};

const mapStateToProps = (state) => ({
  loginIdToken: state.login.id_token,
});

export default connect(mapStateToProps)(CorredorGarantiaDetailBasicInfo);
